import React, { forwardRef, useImperativeHandle } from "react";
import { Form, Input, DatePicker, Checkbox, Select } from "antd";
import moment from "moment";
import Phone from "../inputs/Phone";
import IdentityDocument from "../inputs/IdentityDocument";

const formItemLayout = {
  labelCol: { span: 6, offset: 2 },
  wrapperCol: { span: 16 }
};
const formTailLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12, offset: 8 }
};

const AddPersonForm = forwardRef(
  ({ form, editingPersonInfo, personTypeKey }, ref) => {
    const { getFieldDecorator, getFieldValue } = form;
    useImperativeHandle(ref, () => ({
      form
    }));
    return (
      <Form
        layout={"horizontal"}
        className="add-person-form"
        id="add-person-form"
        hideRequiredMark={true}
      >
        <Form.Item
          label="Фамилия"
          {...formItemLayout}
          style={{ marginBottom: 10 }}
        >
          {getFieldDecorator("last_name")(
            <Input style={{ width: 224 }} placeholder={"Введите фамилию"} />
          )}
        </Form.Item>
        <Form.Item label="Имя" {...formItemLayout} style={{ marginBottom: 10 }}>
          {getFieldDecorator("first_name")(
            <Input style={{ width: 224 }} placeholder={"Введите имя"} />
          )}
        </Form.Item>
        <Form.Item
          label="Отчество"
          {...formItemLayout}
          style={{ marginBottom: 10 }}
        >
          {getFieldDecorator("middle_name")(
            <Input style={{ width: 224 }} placeholder={"Введите отчество"} />
          )}
        </Form.Item>
        <Form.Item
          label="Дата рождения"
          {...formItemLayout}
          style={{ marginBottom: 10 }}
        >
          {getFieldDecorator("birth_date")(
            <DatePicker
              style={{ width: 224 }}
              format={"DD.MM.YYYY"}
              placeholder={"Введите дату"}
              disabledDate={currentDate => currentDate >= moment()}
            />
          )}
        </Form.Item>
        {personTypeKey !== "children" && (
          <Form.Item {...formTailLayout} style={{ marginBottom: 20 }}>
            {getFieldDecorator("acbpdp_need", {
              valuePropName: "checked",
              initialValue: false
            })(
              <Checkbox className={"person_acbpdp"}>
                Для передачи в АЦБПДП
              </Checkbox>
            )}
          </Form.Item>
        )}
        {!!editingPersonInfo ? (
          <>
            <Phone form={form} {...formItemLayout} />
            {personTypeKey !== "children" && (
              <>
                <Form.Item
                  label="Пол"
                  {...formItemLayout}
                  style={{ marginBottom: 10 }}
                >
                  {getFieldDecorator("sex", {
                    initialValue: "male"
                  })(
                    <Select
                      style={{ width: 78, backgroundColor: "#fff" }}
                      dropdownMatchSelectWidth={false}
                      placeholder="Укажите пол"
                    >
                      <Select.Option value="male">Муж.</Select.Option>
                      <Select.Option value="female">Жен.</Select.Option>
                    </Select>
                  )}
                </Form.Item>
                <Form.Item
                  label="Гражданство"
                  {...formItemLayout}
                  style={{ marginBottom: 10 }}
                >
                  {getFieldDecorator("citizenship")(
                    <Input
                      style={{ width: 224 }}
                      placeholder={"Укажите гражданство"}
                    />
                  )}
                </Form.Item>
                <IdentityDocument
                  editingPersonInfo={editingPersonInfo}
                  form={form}
                  {...formItemLayout}
                />
              </>
            )}
          </>
        ) : !!getFieldValue("last_name") &&
          !!getFieldValue("first_name") &&
          !!getFieldValue("birth_date") ? (
          <>
            <Phone form={form} {...formItemLayout} />
            {personTypeKey !== "children" && (
              <>
                <Form.Item
                  label="Пол"
                  {...formItemLayout}
                  style={{ marginBottom: 10 }}
                >
                  {getFieldDecorator("sex", {
                    initialValue: "male"
                  })(
                    <Select
                      style={{ width: 78, backgroundColor: "#fff" }}
                      dropdownMatchSelectWidth={false}
                      placeholder="Укажите пол"
                    >
                      <Select.Option value="male">Муж.</Select.Option>
                      <Select.Option value="female">Жен.</Select.Option>
                    </Select>
                  )}
                </Form.Item>
                <Form.Item
                  label="Гражданство"
                  {...formItemLayout}
                  style={{ marginBottom: 10 }}
                >
                  {getFieldDecorator("citizenship")(
                    <Input
                      style={{ width: 224 }}
                      placeholder={"Укажите гражданство"}
                    />
                  )}
                </Form.Item>
                <IdentityDocument
                  editingPersonInfo={editingPersonInfo}
                  form={form}
                  {...formItemLayout}
                />
              </>
            )}
          </>
        ) : null}
      </Form>
    );
  }
);

const WrappedAddPersonForm = Form.create({ name: "add_person_form" })(
  AddPersonForm
);

export default WrappedAddPersonForm;
